import React from "react";
import { Link } from "react-router-dom";
import { PRODUCT_BREADCRUMBS } from "../../utility/marketingProductNav";

const ProductBreadcrumb = ({ pathname }) => {
  const crumbs = PRODUCT_BREADCRUMBS[pathname];
  if (!crumbs?.length) return null;

  return (
    <nav aria-label="Breadcrumb" className="text-sm text-brand-muted">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1">
        {crumbs.map((crumb, index) => {
          const last = index === crumbs.length - 1;
          return (
            <li key={`${crumb.label}-${index}`} className="inline-flex items-center gap-2">
              {index > 0 ? (
                <span aria-hidden="true" className="text-brand-charcoal/30">
                  ›
                </span>
              ) : null}
              {crumb.to && !last ? (
                <Link to={crumb.to} className="underline text-brand-gold-ink">
                  {crumb.label}
                </Link>
              ) : (
                <span
                  className={last ? "text-brand-charcoal font-medium" : undefined}
                  aria-current={last ? "page" : undefined}
                >
                  {crumb.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default ProductBreadcrumb;
